import HeroSection from './components/HeroSection';
import ServiceHighlights from './components/ServiceHighlights';
import PhotoGallery from './components/PhotoGallery';
import FeaturedArticles from './components/FeaturedArticles';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <main>
      <HeroSection />
      <ServiceHighlights />
      <PhotoGallery />
      <FeaturedArticles />
      <CTASection />
    </main>
  );
}